// api
import { fetchApi } from '@/api'
// actions
const adminCarnetsAll = (context) => {
  let url = 'admin/carnets'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('ADMIN_CARNETS_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const adminCarnetsAllNoAccess = (context) => {
  let url = 'admin/carnets/no/accion'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('ADMIN_CARNETS_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const adminCarnetsReportsAll = (context,payload) => {
  let url = 'admin/carnets/reports'
  let data = JSON.stringify(payload)
  return fetchApi(url, data, 'POST')
    .then((response) => {
      context.commit('ADMIN_CARNETS_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const adminCarnetsReportsAux = (context) => {
  return true;
}

const adminCarnetsForm = (context) => {
  let url = 'admin/carnets/create'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('ADMIN_CARNETS_FORM', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const adminCarnetsShow = (context, payload) => {
  let obj = JSON.parse(payload)
  let data = {}
  let url = 'admin/carnets/' + obj.id + '/edit'
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('ADMIN_CARNETS_SHOW', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

// actions
const adminCarnetsCreate = (context, payload) => {
  let url = 'admin/carnets'
  let obj = JSON.parse(payload)
  obj.id_user_primary = context.getters.adminCarnets.user.id
  payload = JSON.stringify(obj)

  console.log(payload)
  return fetchApi(url, payload, 'POST')
    .then((response) => {
      context.commit('ADMIN_CARNETS_CREATE', response)
      window.history.back()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const adminCarnetsUpdate = (context, payload) => {
  let obj = JSON.parse(payload)
  let url = 'admin/carnets/' + obj.id
  return fetchApi(url, payload, 'PUT')
    .then((response) => {
      context.commit('ADMIN_CARNETS_UPDATE', response)
      //window.history.back()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const adminCarnetsUpdateCode = (context, payload) => {
  let obj = JSON.parse(payload)
  let url = 'admin/carnetscode/' + obj.id
  return fetchApi(url, payload, 'PUT')
    .then((response) => {
      context.commit('ADMIN_CARNETS_UPDATE_CODE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const adminCarnetsDelete = (context, payload) => {
  let obj = JSON.parse(payload)
  let url = 'admin/carnets/' + obj.id
  return fetchApi(url, payload, 'DELETE')
    .then((response) => {
      context.commit('ADMIN_CARNETS_DELETE', response)
      location.reload()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}
const adminValidateUser = (context, idSearch) => {
  let url = 'admin/carnets/' + idSearch
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('ADMIN_VALIDATE_USER', response)
      if (response.code === 1) {
        data.name = response.data.name
        data.response = true
      } else {
        alert(response.message)
        data.name = ''
        data.response = false
      }
      return data
    }).catch((error) => {
      console.error(error)
    })
}

export default {
  adminCarnetsAll,
  adminCarnetsForm,
  adminCarnetsShow,
  adminCarnetsCreate,
  adminCarnetsUpdate,
  adminCarnetsDelete,
  adminValidateUser,
  adminCarnetsUpdateCode,
  adminCarnetsReportsAll,
  adminCarnetsReportsAux,
  adminCarnetsAllNoAccess
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/carnets/actions.js